import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'redeem',
    loadComponent: () =>
      import('./pages/redeem/redeem.component').then((m) => m.RedeemComponent),
  },
  {
    path: 'code/:id',
    loadComponent: () =>
      import('./pages/showcode/showcode.component').then(
        (m) => m.ShowcodeComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
